export default "/_next/static/media/video.83072121.mp4";